<template>
    <v-list-item :key="variant.id" class="px-5 mb-3">
        <v-list-item-icon v-if="pcOnly" class="me-4 me-lg-6">
            <v-icon color="text">mdi-package-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
            <v-list-item-title class="medium-text">{{variant.name}}</v-list-item-title>
            <v-list-item-subtitle class="details-text">
                <div v-if="product.track_stock">
                    <template v-if="variant.stock && variant.stock < 10">
                        <v-icon color="orange darken-2" class="me-2" size="18">mdi-progress-alert</v-icon>
                        <span class="orange--text text--darken-2">المخزون المتوفر: <b>{{variant.stock}}</b></span>
                    </template>
                    <template v-else-if="variant.stock === 0">
                        <v-icon color="error" class="me-1" size="17">mdi-alert</v-icon>
                        <span class="error--text">انتهى مخزون المنتج</span>
                    </template>
                    <template v-else-if="variant.stock">
                        <v-icon color="primary" class="me-1" size="17">mdi-package-variant-closed</v-icon>
                        <span>المخزون المتوفر: <span class="primary--text">{{unitFormat(variant.stock, 'قطعة', 'قطعتين', 'قطع')}}</span></span>
                    </template>
                    <template v-else>
                        <v-icon color="muted" class="me-1" size="17">mdi-alert-circle-outline</v-icon>
                        <span>المخزون غير محدد</span>
                    </template>
                </div>
                <div v-else>
                    <v-icon color="grey" class="me-2" size="16">mdi-close-circle-outline</v-icon>
                    <span>تتبع المخزون غير مفعل</span>
                </div>
            </v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-icon>
            <div class="d-flex align-center">
                <span v-if="variant.discount" class="medium-text muted--text me-1" style="text-decoration: line-through;">{{moneyFormat(beforeDiscount)}}</span>
                <div>
                    <span style="font-size: 1.1rem">{{moneyFormat(priceComputed)}}</span>
                    <small class="ms-1 muted--text small-text">د.ع</small>
                </div>
                <div style="margin-left: -12px" class="ms-2">

                    <v-menu bottom left :offset-y="true" transition="slide-y-transition">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon color="muted" style="opacity: 0.75" v-bind="attrs" v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense min-width="150" >
                            <v-list-item :disabled="!product.track_stock" dense @click="openStockDialog">
                                <v-list-item-icon class="me-1" :style="!product.track_stock ? 'opacity: 0.5' : ''">
                                    <v-icon color="primary" size="19">mdi-package-variant-closed</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="medium-text">إدارة المخزون</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="openDiscountDialog">
                                <v-list-item-icon class="me-1">
                                    <v-icon color="green" size="19">mdi-label-percent-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="medium-text">{{variant.discount ? 'تعديل الخصم' : 'إضافة خصم'}}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="openEditDialog">
                                <v-list-item-icon class="me-1">
                                    <v-icon color="text" size="19">mdi-square-edit-outline</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="medium-text">تعديل</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-list-item dense @click="deleteDialog = true">
                                <v-list-item-icon class="me-1">
                                    <v-icon color="red" size="19">mdi-delete</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title class="medium-text">حذف</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </div>
            </div>
        </v-list-item-icon>

        
        <action-dialog v-model="editDialog" scrollable max-width="420" vuex-action="editProductVariant" success-msg="تم حفظ التغييرات بنجاح" title="تعديل خيار المنتج" subtitle="سيتم تنفيذ التغييرات لحظياً" button-text="تعديل" :data="{id: variant.id, data: editedItem}" @sync="sync">
            <div class="pt-1">
                <v-text-field v-model="editedItem.name" label="اسم الخيار" placeholder="أدخل اسم لخيار الشراء" hide-details class="mb-5"></v-text-field>

                <v-text-field v-model="editedItem.price" type="number" label="السعر" placeholder="أدخل السعر" min="0" hide-details suffix="" class="mb-5"></v-text-field>
            </div>
        </action-dialog>

        <action-dialog v-model="discountDialog" scrollable max-width="325" vuex-action="editProductVariant" success-msg="تم حفظ التغييرات بنجاح" title="خصم على المنتج" subtitle="اترك الحقل فارغاً لإلغاء الخصم" button-text="تأكيد" :data="{id: variant.id, data: {discount: (discountValue ? discountValue : 0)}}" @sync="sync">
            <div class="pt-1">
                <v-text-field v-model="discountValue" type="number" label="قيمة الخصم" placeholder="أدخل قيمة الخصم (د.ع)" min="0" hide-details suffix="" class="mb-5"></v-text-field>
            </div>
        </action-dialog>

        <action-dialog v-if="product.track_stock" v-model="stockDialog" scrollable max-width="420" vuex-action="editProductVariant" success-msg="تم حفظ التغييرات بنجاح" title="تعديل المخزون" subtitle="يمكنك تعديل مخزون المنتج يدوياً باﻹضافة أو النقصان" button-text="تعديل" :data="{id: variant.id, data: {stock: newStock}}" @sync="sync">
        
            <v-text-field v-model="newStock" autofocus type="number" label="الكمية المتوفرة" placeholder="أدخل الكمية المتوفرة من مخزون المنتج" append-icon="mdi-package-variant" min="0" hide-details suffix="" class="mb-5"></v-text-field>

        </action-dialog>

        <action-dialog v-model="deleteDialog" vuex-action="deleteProductVariant" :title="`حذف خيار المنتج`" :data="{id: variant.id}" button-text="تأكيد الحذف" button-color="error" @sync="sync">
            هل أنت متأكد من حذف الخيار <span class="strong-text--text">"{{variant.name}}"</span> ؟
        </action-dialog>
    </v-list-item>    
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        product: {},
        variant: {},
    },
    data(){
        return {
            editDialog: false,
            editedItem: {
                name: '',
                price: '',
            },
            
            discountDialog: false,
            discountValue: '',
            
            stockDialog: false,
            newStock: '',

            deleteDialog: false,
        };
    },
    watch :{
        
    },
    computed: {
        ...GlobalComputed,
        priceComputed(){
            const variant = this.variant,
                discount = variant.discount ? variant.discount : 0;
            return variant.price - discount;
        },
        beforeDiscount(){
            return this.variant.price;
        },
        
    },
    methods: {
        ...GlobalMethods,
        openEditDialog(){
            this.editedItem = {
                name: this.variant.name,
                price: this.variant.price
            };
            this.editDialog = true;
        },
        openStockDialog(){
            this.newStock = this.variant.stock;
            this.stockDialog = true;
        },
        openDiscountDialog(){
            this.discountValue = this.variant.discount;
            this.discountDialog = true;
        },
        sync(payload){
            this.$emit('sync', payload);
        }
    }
}
</script>
